import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { setAssetPath } from '@ionic/core/components';

if (environment.production) {
  enableProdMode();
}

setAssetPath(document.baseURI)

bootstrapApplication(AppComponent, appConfig)
.catch(err => console.error(err));
 